<template>
  <div class="ReportRepair">
    <van-cell-group class="addressBox">
      <van-cell title="地址" is-link value="点击选择地址" @click="gotoPath('/addressmanage')" class="addressBtn"/>
      <van-cell :value="saveData.address" class="address"/>
    </van-cell-group>
    <van-cell-group>
      <van-cell title="电话报修" :value="Repairphone" @click="callPhone" class="Repairphone"/>
    </van-cell-group>
    <van-cell-group class="cardIcon">
      <van-field
        v-model="saveData.name"
        required
        clearable
        label="姓名"
        placeholder="请输入姓名"
      />
      <van-field
        class="phone"
        v-model="saveData.phone"
        required
        clearable
        label="电话"
        placeholder="请输入联系电话"
        @blur = "Cardtest('phone')"
      />
    </van-cell-group>
	<!-- <van-cell-group class="addressBox">
	  <van-cell title="报修类型" is-link :value="repairType" @click="onRepair"/>
	</van-cell-group> -->
    <van-cell-group class="quick">
      <van-tabs v-model="activeName" @click="onClick">
        <van-tab v-for="(item,index) in RepairType" :title="item.repairType.id" :key="item.repairType.id" :name="item.repairType.id">
          <div slot="title" @click="getTypeId(item.repairType.id)">{{item.repairType.name}}</div>
          <van-cell :value="items.question" v-for="(items,index) in item.repairFaqList" :key="items.id" class="repairFaq" @click="ckeckRepairFaq($event,items.id,items.question)"/>
        </van-tab>
      </van-tabs>
    </van-cell-group>
    <van-cell-group class="reason">
      <div class="reasonBox"><label>报修描述</label></div>
      <div class="reasonBox"><textarea name="reason" @blur="Cardtest" placeholder="请点击选择快捷语或输入描述" cols="30" rows="8"  v-model="saveData.reason"></textarea></div>
      <div class="ImgBar">
        <span v-for="(item,index) in fileList" :key="index" class="ImgBox">
          <img :src="item" alt="图片" class="uploadimg" @click="ImagePreviewShow">
          <van-icon name="delete" @click="delImg(index)" class="delte"/>
        </span>
        <van-uploader :after-read="onRead" accept="image/*" multiple :max-count="5" upload-text="最多可上传5张" class="imgList"/>
      </div>
    </van-cell-group>
	<van-cell-group>
	  <van-cell title="紧急程度" is-link :value="urgencyStatusData.codeLabel" @click="onUrgencyStatus"/>
	</van-cell-group>
	<!-- <van-cell-group>
	  <van-row>
	    <van-col span="19"><van-field v-model="saveData.handleExpireTime" type="digit" label="处理期限" placeholder="请输入期限时间" /></van-col>
	    <van-col span="5" style="border-left: 1px solid #F9F9F9;">
			<van-cell is-link :value="handleExpireUnitData.codeLabel" @click="onHandleExpireUnit"/>
		</van-col>
	  </van-row>
	</van-cell-group> -->
	<!-- <van-cell-group>
	  <van-cell title="预约时间" is-link :value="saveData.reservationTime" @click="onReservationTime"/>
	</van-cell-group> -->
    <van-col span="24" type="flex" justify="space-between" class="barBtn">
      <van-button round type="danger" size="large" class="saveBth" @click.prevent="UpdateInfo">提交</van-button>
    </van-col>
    <van-popup v-model="iscallPhoneShow" class="callPhonePop">
      <div class="phoneText"><span>拨打</span>{{this.Repairphone}}</div>
      <div><a href="javaScript:;" class="bth cancel">取消</a><a class="bth confirm" :href="'tel:'+Repairphone">确定</a></div>
    </van-popup>
	<van-popup
	  v-model="isShow"
	  position="bottom"
	>
		<van-picker
		  show-toolbar
		  :columns="columns"
		  @confirm="onRepairConfirm"
		  @cancel="isShow = false"
		  v-show="isRepair"
		  value-key="companyName"
		/>
		<van-picker
		  show-toolbar
		  :columns="urgencyStatusColumns"
		  @confirm="onUrgencyStatusConfirm"
		  @cancel="isShow = false"
		  v-show="isUrgencyStatus"
		  value-key="codeLabel"
		/>
		<van-picker
		  show-toolbar
		  :columns="handleExpireUnitColumns"
		  @confirm="onHandleExpireUnitConfirm"
		  @cancel="isShow = false"
		  v-show="isHandleExpireUnit"
		  value-key="codeLabel"
		/>
		<van-datetime-picker
		  v-model="reservationTimeDate"
		  @confirm="onReservationTimeConfirm"
		  @cancel="isShow = false"
		  type="datetime"
		  title="选择预约时间"
		  :min-date="minDate"
		  v-show="isReservationTime"
		/>
	</van-popup>
  </div>
</template>

<script>
  import { Toast, ImagePreview } from 'vant'
  import envJS from '../../common/js/env'
  import {reqRepairphone, reqRepairType, reqUploaderImg,reqRepairOrderAdd} from '../../api'
  export default {
    name:"reportrepair",
    i18n: {
      'zh-CN': {
        text: '文本',
        customIndexList: '自定义索引列表'
      },
      'en-US': {
        text: 'Text',
        customIndexList: 'Custom Index List'
      }
    },
    data() {
      return {
        activeName:'',
        iscallPhoneShow:false,
        isSave:true,
        Repairphone:envJS.Repairphone,
        imgList: [],
        fileList:[],
        saveData:{
          address:'请选择您所在地址',//机构id
          userId:'',//用户id
          name:'',//姓名
          phone:'',//电话
          scope:'3',// 0/具体房屋 1/小区公共区域 2/小区外公共区域
          roomId:'',//房屋ID
          reason:'',//留言
          imageurls:'',//图片地址，多张逗号隔开
          typeId:'',//快捷语类型id
		  faqId:'',
          orderType:'1',//1/报修
          companyId:'',//机构id
		  urgencyStatus:'2',//紧急程度	，默认不紧急2
		  handleExpireTime:'',//处理期限
		  handleExpireUnit:'3',//期限单位 ，默认天3
		  reservationTime:''//预约时间
        },
        RepairType:[],
        files:[],
        filesSum:0,
        headerImage: null,
        picValue: null,
        upImgUrl:'',
		isShow:false,
		isRepair:false,
		columns:[],
		repairType:"请选择报修类型",
		urgencyStatusData:{
			codeLabel:"不紧急",
			codeValue:"2",
		},
		urgencyStatusColumns:[{
			codeLabel:"紧急",
			codeValue:"1",
		},{
			codeLabel:"不紧急",
			codeValue:"2",
		},{
			codeLabel:"一般",
			codeValue:"3",
		}],
		urgencyStatus:'2',//紧急程度	，默认不紧急2
		isUrgencyStatus:false,
		handleExpireTime:'',//处理期限
		isHandleExpireUnit:false,//是否显示期限单位
		handleExpireUnitData:{
			codeLabel:"天",
			codeValue:"3",
		},//期限单位，默认天3
		handleExpireUnitColumns:[{
			codeLabel:"分",
			codeValue:"1",
		},{
			codeLabel:"时",
			codeValue:"2",
		},{
			codeLabel:"天",
			codeValue:"3",
		}],
		isReservationTime:false,//是否显示选择时间
		reservationTimeDate:'',//
		reservationTime:'',//预约时间
		minDate:new Date()
      }
    },
    created(){
      this.getRepairType()
      let repairAddress = this.$cookies.get('repairAddress')
      if(this.$route.query.roomId){
		console.log(this.$route.query)
        this.$cookies.remove('repairAddress');
        this.saveData.roomId = this.$route.query.roomId;
        if(this.$cookies.get('address')){
          this.saveData.address = this.$cookies.get('address')
        }
      }else if(this.$route.query.source=='order'){
        this.$cookies.remove('address');
        if(repairAddress){
          this.saveData.roomId = repairAddress.roomId;
          this.saveData.address = repairAddress.address;
        }
      }
      this.saveData.userId = this.$cookies.get('userInfo').userId
      this.saveData.companyId = this.$cookies.get('companyId')
    },
    computed: {
      isPhone () {
        return /^1\d{10}$/.test(this.saveData.phone)
      }
    },
    mounted(){
      /*
      * 查询客服电话
      * */
      // if(this.saveData.roomId){
      //   let data={
      //     roomId:this.saveData.roomId,
      //     companyId:this.$cookies.get('companyId'),
      //     type:0
      //   }
      //   reqRepairphone(data).then(res => {
      //     if(res.success){
      //       this.Repairphone = res.data.phone;
      //     }else {
      //       // Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
      //       console.log('系统错误，请联系管理员！');
      //     }
      //   })
      // }
    },
    methods:{
      //跳转地址选择
      gotoPath(path){
        this.$router.push({
          path:path,
          name:path.substring(1),
          query:{type:1}
        })
      },
      /*
      * 获取维修类型
      * */
      getRepairType(){
          let data = {
            orderType: 0,
            target: 0
          }
        reqRepairType(data).then(res => {
          if(res.success){
            this.RepairType = res.data
          }else {
            Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
          }
        })
      },
      /*
      * 点击拨打电话
      * */
      callPhone(){
        if(this.Repairphone) {
          this.iscallPhoneShow = true
        }
      },
      /*
      * 点击选择维修类型
      */
      onClick(name,title) {
        this.saveData.typeId = title;
      },
	  /*
	  *  点击获取报修类型列表
	  * */
	  onRepair(){
	  		  this.repairType = '请选择报修类型'
	  		  this.isShow = true
			  this.isRepair = true
	  		  this.reqCompanyData();
	  },
	  /*
	  *
	  **/
	  reqRepair(){

	  },
	  /*
	  * 点击报修类型选取弹窗确定
	  * */
	  onRepairConfirm(){
		  this.isShow = false
		  this.isRepair = false
	  },
      /*
      * 选择快捷语
      * */
      ckeckRepairFaq($event,id,question){
		this.saveData.faqId = id;
        this.saveData.reason = question;
      },
      // 组件方法 获取 流
      async onRead(file) {
        this.files=[];
        this.picValue=[];
        if(file.length){
          this.files = file
          this.picValue = file; // 文件流
        }else{
          this.files.push(file);
          this.picValue.push(file);
        }
        this.filesSum +=this.files.length;
        if(this.filesSum > 5){
          Toast.fail({message:'图片最多上传5张！',className:'apiLoading'});
          return false
        }
        if(this.files.length > 5){
          Toast.fail({message:'图片最多上传5张！',className:'apiLoading'});
          return false
        }
        for(var k in this.picValue){
          this.imgPreview(this.picValue[k].file,k);
        }
      },
      // 处理图片
      imgPreview(file,k) {
        let self = this;
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;
        if (/^image/.test(file.type)) {
          // 创建一个reader
          let reader = new FileReader();
          // 将图片2将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function () {
            // console.log(this.result);
            let result = this.result;
            let img = new Image();
            img.src = result;
            //判断图片是否大于500K,是就直接上传，反之压缩图片
            if (this.result.length <= 500 * 1024) {
              self.headerImage = this.result;
              self.postImg(k);
            } else {
              img.onload = function () {
                let data = self.compress(img,k);
                self.headerImage = data;
                self.postImg(k);
              };
            }
          };
        }
      },
      // 压缩图片
      compress(img,k) {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        //瓦片canvas
        let tCanvas = document.createElement("canvas");
        let tctx = tCanvas.getContext("2d");
        // let initSize = img.src.length;
        let width = img.width;
        let height = img.height;
        //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        let ratio;
        if ((ratio = (width * height) / 4000000) > 1) {
          // console.log("大于400万像素");
          ratio = Math.sqrt(ratio);
          width /= ratio;
          height /= ratio;
        } else {
          ratio = 1;
        }
        canvas.width = width;
        canvas.height = height;
        //        铺底色
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        //如果图片像素大于100万则使用瓦片绘制
        let count;
        if ((count = (width * height) / 1000000) > 1) {
          // console.log("超过100W像素");
          count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
          //            计算每块瓦片的宽和高
          let nw = ~~(width / count);
          let nh = ~~(height / count);
          tCanvas.width = nw;
          tCanvas.height = nh;
          for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
              tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
              ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
          }
        } else {
          ctx.drawImage(img, 0, 0, width, height);
        }
        //进行最小压缩
        let ndata = canvas.toDataURL("image/jpeg", 0.1);
        tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
        return ndata;
      },
      //将base64转换为文件
      dataURLtoFile(dataurl,k) {
        var arr = dataurl.split(","),
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], this.files[k].file.name, {
          type: this.files[k].file.type
        });
      },
      //这里写接口
      async postImg(k) {
        let file = this.dataURLtoFile(this.headerImage,k);
        if(this.fileList.length > 5){
          Toast.fail({message:'图片最多上传5张！',className:'apiLoading'});
          return false
        }
        let formData = new window.FormData();
        formData.append("headImg", file);
        formData.append('userId', this.$cookies.get('userInfo').userId);
        try {
          // 此时可以自行将文件上传至服务器
          reqUploaderImg(formData).then(res => {
            if(res.success){
              this.imgList.push(res.data.headUrl);
              this.fileList.push(res.data.headUrl);
            }else {
              Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
            }
          })
        } catch (e) {
          console.log(e);
        }
      },
      /*
      * 删除图片
      * */
      delImg(index){
        console.log(index);
        this.imgList.splice(index,1)
        this.fileList.splice(index,1)
        this.filesSum--
      },
      /*
      * 预览图片
      * */
      ImagePreviewShow(){
        ImagePreview({
          images:this.fileList,
          showIndicators:true
        })
      },
      /*
      * 失去焦点必填验证
      * */
      Cardtest(type){
        if(type=='phone'){
          if(!this.isPhone){
            Toast.fail({message:'请输入正确手机号！',className:'apiLoading'});
            return false
          }
        }else{
          this.testVerify();
        }
      },
	  /**
	   * 点击显示紧急程度
	   * **/
	  onUrgencyStatus(){
		  this.isShow = true;
		  this.isUrgencyStatus = true;
	  },
	  /**
		* 选择紧急程度
		* **/
	  onUrgencyStatusConfirm(value,index){
	  		   this.urgencyStatusData.codeLabel = value.codeLabel;
	  		   this.urgencyStatusData.codeValue = value.codeValue;
	  		   this.saveData.urgencyStatus = this.urgencyStatusData.codeValue;
	  		   this.isShow = false;
	  		   this.isUrgencyStatus = false;
	  },
	  /**
	   * 点击显示时间单位
	   * **/
	   onHandleExpireUnit(){
		   this.isShow = true;
		   this.isHandleExpireUnit = true;
	   },
	   /**
		* 选择时间单位
		* **/
	   onHandleExpireUnitConfirm(value,index){
		   this.handleExpireUnitData.codeLabel = value.codeLabel;
		   this.handleExpireUnitData.codeValue = value.codeValue;
		   this.saveData.handleExpireUnit = this.handleExpireUnitData.codeValue;
		   this.isShow = false;
		   this.isHandleExpireUnit = false;
	   },
	  /**
	   *点击弹出选择时间
	   * **/
	  onReservationTime(){
		  this.isShow = true;
		  this.isReservationTime = true;
	  },
	  /**
	   * 选择时间
	   * **/
	   onReservationTimeConfirm(date){
		   console.log(date);
			this.saveData.reservationTime =  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
		   this.isShow = false;
		   this.isReservationTime = false;
	   },
      /*
     *  必填验证
     * */
      testVerify(){
        if(!this.saveData.address&&!this.saveData.roomId){
          Toast.fail({message:'请选择地址！',className:'apiLoading'});
          return false
        }
        if(!this.isPhone){
          Toast.fail({message:'请输入正确手机号！',className:'apiLoading'});
          return false
        }
        if(!this.saveData.name){
          Toast.fail({message:'请输入姓名！',className:'apiLoading'});
          return false
        }
        if(!this.saveData.typeId){
          Toast.fail({message:'请点击选择维修类型！',className:'apiLoading'});
          return false
        }
        if(!this.saveData.reason){
          Toast.fail({message:'请点击选择则快捷语或填写报修描述！',className:'apiLoading'});
          return false
        }
        // if(this.imgList.length == 0){
        //   Toast.fail({message:'请添加相关图片！',className:'apiLoading'});
        //   return false
        // }
        return true
      },
      /*
      * 去查询
      * */
      UpdateInfo(){
        var _that=this
        this.testVerify();
        let testVerify = this.testVerify();
        if(testVerify){
          this.saveData.imageurls = this.imgList.join(",")
          // 提交供热报修
          console.log(this.saveData);
		  this.saveData.serviceType = '3'
          reqRepairOrderAdd(this.saveData).then(res => {
          if(res.success){
            Toast.success({message:'提交成功！',className:'apiLoading',onClose:function(){
                _that.$cookies.remove('address');
                _that.$cookies.remove('repairAddress');
                _that.$router.push({
                  path:'/repairorder',
                  name:'repairorder'
                })
              }});
          }else {
            Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
          }
        })
        }
      },

    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .ReportRepair
    .van-cell-group
      margin-top 8px
      .van-cell
        height 98px
        line-height 98px
        font-size 30px
        color #222222
        padding-left 40px
        .van-cell__value
          font-size 28px
        .van-cell__left-icon, .van-cell__right-icon
          font-size 26px
          margin 0px 10px
          line-height 98px
        .van-field__control
          text-align right
          padding-right 40px
        .van-field__label
          width 120px
      .address
        height auto
        line-height 45px
      .addressBtn
        .van-cell__value
          span
            padding 5px 0px 5px 50px!important
            background url("./images/location_icon.png") no-repeat center left
            background-size 32px auto
      .Repairphone
        .van-cell__value
          span
            padding 5px 20px 5px 60px!important
            background url("./images/tel_btn.png") no-repeat center left
            background-size 40px auto
      .repairFaq
        border-bottom 1px solid #eee
        height 78px
        line-height 68px
      .activeFaq
        background #f8f8f8
    .reason
      .reasonBox
        font-size 30px
        padding 20px 40px
      textarea
        width 90%
        border 0px
        padding 30px 30px
        background #f6f6f6
    .quick
      .van-tab
        line-height 75px
        font-size 28px
      .van-tabs--line .van-tabs__wrap
        height 80px
      .van-tabs__content
        margin-top 38px
        min-height 400px
    .van-picker__toolbar
      height 85px
      .van-picker__confirm, .van-picker__cancel
        font-size 28px
        line-height 85px
    .van-picker-column
      font-size 32px
    .cardIcon
      padding-right 10px
      .phone
        border-bottom 1px solid #eee
      input
        padding-right 50px!important
        background-size 32px auto
    .imgList
      vertical-align top
      .van-uploader__upload
        width 150px
        height 150px
      .van-uploader__preview
        width 150px
        height 150px
    .barBtn
      padding 10% 40px 60px
      background #f9f9f9
      .saveBth
        color #ffffff
        font-size 32px
        background #ff6d02
        height 88px
        margin 0px 0px 100px
        line-height 88px
    .van-index-bar
      padding 0px 30px
      .van-index-bar__index
        font-size 24px
        line-height 40px
      .van-index-anchor
        font-size 30px
        background #ccc
        padding 8px 10px
      .van-cell
        font-size 28px
        padding 10px 20px
        line-height 45px
        border-bottom 1px solid #ccc
    .ImgBar
      padding 0px 40px 40px
      .ImgBox
        position relative
        .uploadimg
          width 150px
          height 150px
        .delte
          font-size 32px
          position absolute
          padding 3px 2px
          bottom 8px
          right 8px
          color #fff
          background rgba(0,0,0,0.6)
    .callPhonePop
      min-width 60%
      padding 40px 0px 10px
      .phoneText
        padding 60px 80px 50px
        text-align center
        border-bottom 1px solid #eee
      .bth
        width 49%
        padding 30px 0px
        text-align center
        display inline-block
      .confirm
        color #1989fa
        border-left 1px solid #eee
	.van-picker-column__item
		height 1rem
	// #app
	// 	height auto
</style>



// WEBPACK FOOTER //
// src/pages/heatReportRepair/ReportRepair.vue